/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Disable_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to disable SCIM provisioning" |
*
* @param {Scim_Disable_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_disable_error = /** @type {((inputs?: Scim_Disable_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Disable_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Deaktivieren der SCIM-Bereitstellung")
	return /** @type {LocalizedString} */ ("Failed to disable SCIM provisioning")
});